import React from "react";

interface BadgeProps {
  status: "Active" | "Inactive" | string;
}

export const Badge: React.FC<BadgeProps> = ({ status }) => {
  const isActive = status === "Active";
  return (
    <span
      className={`inline-flex items-center font-bold px-2.5 py-1 rounded-lg text-xs leading-none border shadow-sm ${
        isActive
          ? "bg-emerald-50 text-emerald-700 border-emerald-200/50"
          : "bg-rose-50 text-rose-700 border-rose-200/50"
      }`}
    >
      <span
        className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
          isActive ? "bg-emerald-500" : "bg-rose-500"
        }`}
      />
      {status}
    </span>
  );
};
